var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32031 12H15.6797V2H2.32031V12ZM0.679688 0.320312H17.3203V13.6797H0.679688V0.320312ZM13.1797 8.67969V5.32031H12.3203V8.67969H13.1797ZM14 3.67969C14.2344 3.67969 14.4297 3.75781 14.5859 3.91406C14.7422 4.07031 14.8203 4.26562 14.8203 4.5V9.5C14.8203 9.73438 14.7422 9.92969 14.5859 10.0859C14.4297 10.2422 14.2344 10.3203 14 10.3203H11.5C11.2656 10.3203 11.0703 10.2422 10.9141 10.0859C10.7578 9.92969 10.6797 9.73438 10.6797 9.5V4.5C10.6797 4.26562 10.7578 4.07031 10.9141 3.91406C11.0703 3.75781 11.2656 3.67969 11.5 3.67969H14ZM8.17969 8.67969V5.32031H7.32031V8.67969H8.17969ZM9 3.67969C9.23438 3.67969 9.42969 3.75781 9.58594 3.91406C9.74219 4.07031 9.82031 4.26562 9.82031 4.5V9.5C9.82031 9.73438 9.74219 9.92969 9.58594 10.0859C9.42969 10.2422 9.23438 10.3203 9 10.3203H6.5C6.26562 10.3203 6.07031 10.2422 5.91406 10.0859C5.75781 9.92969 5.67969 9.73438 5.67969 9.5V4.5C5.67969 4.26562 5.75781 4.07031 5.91406 3.91406C6.07031 3.75781 6.26562 3.67969 6.5 3.67969H9ZM3.17969 3.67969H4.82031V10.3203H3.17969V3.67969Z",
    fill: "#105099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.2b9e26835c2be2e2f4ab931bd8ea0e65.svg";
export { ForwardRef as ReactComponent };